import styled from 'styled-components';

const StyledBoxPlot= styled.div`

	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right 0;


	.af-title {
		position: absolute;
		top: 0;
		left:0;
		right: 0;
		color: #fff;
		padding-top: 30px;
		font-family: 'Sans', 'RijksoverheidSansText-Regular', 'RijksoverheidSansText', Arial, sans-serif;
		font-weight: 600;
		font-size: 21px;
	}

	.af-source {
		position: absolute;
		bottom: 0;
		left:0;
		right: 0;
		color: #fff;
		//font-family: 'Sans', 'RijksoverheidSansText-Regular', 'RijksoverheidSansText', Arial, sans-serif;
		font-weight: 400;
		text-align: right;
		padding: 15px;

		font-size: 12px;
		font-family: sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;

		a {
			color: #fff;
		}
	}

	svg {
    width: 100%;
    height: 100%;

		text {
			font-family: 'Sans', 'RijksoverheidSansText-Regular', 'RijksoverheidSansText', Arial, sans-serif;
		}

		.axis {
			text {
				font-size: 13px;
				font-family: sans-serif;
				-webkit-font-smoothing: antialiased;
				-moz-osx-font-smoothing: grayscale;
			}
		}

		.axis.y {
			.domain {
				display: none;
			}
			.tick {
				line {
					display: none;
				}
			}
		}

		.af-boxplot-tooltip {
			text {
				font-size: 12px;
			}
		}


	}


}
`;

export default StyledBoxPlot;



// WEBPACK FOOTER //
// ./src/components/BoxPlot/StyledBoxPlot.js